import styled from 'styled-components';

export const WrapperCasosBordes = styled.div`
    display: grid;
    gap: 1.9rem;
    padding-bottom: 25px;

    h1{
        color: #383638;
        font-size: 1.7rem;
        font-weight: bold;
    }
    h2{
        font-size: 1.3rem;
        line-height: 20px;
        text-align: center;
    }
    .reintentar button {
        color: white;
        background-color: #e81e2b;
        min-width: 225px;
        justify-content: center;
    }
    .reintentar button:hover {
        background-color: #e81e2b;
        color: white;
    }
    .volver button span {
        text-decoration: none !important;
    }
    .volver {
        width: 30%;
    }
    .volver button::before {
        content: "<";
        font-size: 27px;
        font-weight: 500;
        position: relative;
        right: 20px;
        top: -2px;
    }
    img{
        margin: 0 auto;
        width: 24%;
    }
    p{
        font-size: 1rem;
        text-align: center;
    }
    ._3NSXd {
        font-size: 1rem !important;
    }
    .mensaje-contenedor p {
        font-size: 0.7rem;
        text-align: left;
    }
    button{
        margin: 0 auto;
    }
    button span {
        font-size: 1rem;
    }
    @media (max-width: 426px){
        gap: 1.4rem;
        h1{
            color: #383638;
            font-size: 1.2rem;
            font-weight: bold;
        }
        h2{
            font-size: 1rem;
            line-height: 20px;
            text-align: center;
        }
        img{
            margin: 0 auto;
            width: 30%;
        }
        p{
            font-size: 0.8rem;
            text-align: center;
        }
        ._3NSXd {
            font-size: 0.8rem !important;
        }
        .mensaje-contenedor p {
            font-size: 0.8rem;
        }
        .mensaje-contenedor {
            width: 100%;
            max-width: initial;
            margin-left: inherit !important;
        }
        .tarjeta-contenedor{
            background-color: black;
            padding: 20px;
        }
        button span {
            font-size: 0.8rem;
        }
        .volver {
            width: 100%;
        }
    }
    @media (max-width: 375px){
        .volver {
            width: 100%;
        }
    }
    @media (max-width: 321px){
        h1{
            color: #383638;
            font-size: 1.1rem;
            font-weight: bold;
        }
        h2{
            font-size: 0.9rem;
            line-height: 20px;
            text-align: center;
        }
        img{
            margin: 0 auto;
            width: 38%;
        }
        p{
            font-size: 0.8rem;
            text-align: center;
        }
        ._3NSXd {
            font-size: 0.7rem !important;
        }
        .mensaje-contenedor p {
            font-size: 0.7rem;
        }
        button span {
            font-size: 0.8rem;
        }
        .volver {
            width: 100%;
        }
    }
`;

export default WrapperCasosBordes;